<template>
  <div
    v-if="$store.state?.hunter?.avatar"
    :class="['avatar__full', { '--head': head, '--nav': nav, '--tiny': tiny }]"
  >
    <Image :source="$store.state.clothing.all.skin[$store.state.hunter.avatar.skin].image" />
    <Image :source="$store.state.clothing.all.shoes[$store.state.hunter.avatar.shoes].image" />
    <Image :source="$store.state.clothing.all.bottom[$store.state.hunter.avatar.bottom].image" />
    <Image :source="$store.state.clothing.all.top[$store.state.hunter.avatar.top].image" />
    <Image :source="$store.state.clothing.all.hair[$store.state.hunter.avatar.hair].image" />
    <Image :source="$store.state.clothing.all.hat[$store.state.hunter.avatar.hat].image" />
    <!--    <Image :source="$store.state.clothing.all.object[$store.state.hunter.avatar.object].image"/>-->
    <Image
      :source="$store.state.clothing.all.accessory[$store.state.hunter.avatar.accessory].image"
    />

    <Image :source="$beet.options.hunt.lines" class="--lines" />
  </div>
</template>

<script>
import { Image } from '@/components/global'

export default {
  name: 'AvatarBody',
  components: { Image },
  props: {
    head: {
      type: Boolean,
      default: false,
    },
    nav: {
      type: Boolean,
      default: false,
    },
    tiny: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
